import React, { useEffect, useMemo, useRef, useState } from 'react';
import 'react-toastify/dist/ReactToastify.css';
import './Banners.css';
import SwiperCore, { Navigation, Pagination, Autoplay } from 'swiper/core';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css';
import { useBanners } from '../storeData';
SwiperCore.use([Navigation, Pagination, Autoplay]);

export default function Banners() {
    const swiperRef = useRef(null);
    const [selectedImage, setSelectedImage] = useState(null);
    const { data: banners, loading } = useBanners();
    const images = useMemo(() => banners?.map(banner => banner.imagen)?.filter(Boolean) || [], [banners]);

    useEffect(() => {
        if (swiperRef.current) {
            swiperRef.current?.update();
        }
    }, [images]);

    useEffect(() => {
        const swiper = swiperRef.current;
        if (!swiper?.autoplay) return;

        if (selectedImage) {
            swiper.autoplay.stop();
        } else {
            swiper.autoplay.start();
        }
    }, [selectedImage]);

    useEffect(() => {
        if (!selectedImage) return undefined;

        const handleKeyDown = (event) => {
            if (event.key === 'Escape') {
                setSelectedImage(null);
            }
        };

        document.body.style.overflow = 'hidden';
        window.addEventListener('keydown', handleKeyDown);

        return () => {
            document.body.style.overflow = '';
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [selectedImage]);

    return (
        <div className='BannerContain'>

            {loading ? (
                <div className='loadingBanner'>

                </div>

            ) : (
                <Swiper
                    effect={'coverflow'}
                    grabCursor={true}
                    loop={true}
                    slidesPerView={'auto'}
                    coverflowEffect={{ rotate: 0, stretch: 0, depth: 100, modifier: 2.5 }}
                    navigation={{ nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' }}
                    autoplay={{ delay: 3000 }}
                    pagination={{ clickable: true }}
                    onSwiper={(swiper) => {
                        swiperRef.current = swiper;
                    }}
                    id='swiper_container'
                >
                    {images?.map((image, index) => (
                        <SwiperSlide id='SwiperSlide-scroll' key={index}>
                            <button
                                type='button'
                                className='bannerImageButton'
                                onClick={() => setSelectedImage(image)}
                                aria-label='Ver banner completo'
                            >
                                <img src={image} alt={`imagen-${index}`} />
                            </button>
                        </SwiperSlide>
                    ))}
                </Swiper>
            )}

            {selectedImage && (
                <div
                    className='bannerPreviewOverlay'
                    role='dialog'
                    aria-modal='true'
                    aria-label='Banner ampliado'
                    onClick={() => setSelectedImage(null)}
                >
                    <div className='bannerPreviewContent' onClick={(event) => event.stopPropagation()}>
                        <button
                            type='button'
                            className='bannerPreviewClose'
                            onClick={() => setSelectedImage(null)}
                            aria-label='Cerrar banner'
                        >
                            ×
                        </button>
                        <img src={selectedImage} alt='Banner ampliado' />
                    </div>
                </div>
            )}
        </div>
    );
}
